import { initializeApp } from "firebase/app";
import {
  getAnalytics,
  logEvent,
  setCurrentScreen,
  setUserProperties,
  setUserId,
} from "firebase/analytics";

let analytics = null;
let initialized = false;

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

function isConfigValid(cfg) {
  return Boolean(cfg.apiKey && cfg.projectId && cfg.appId);
}

export function useFirebase() {
  async function initFirebase() {
    if (initialized) return;
    initialized = true;
    if (!isConfigValid(firebaseConfig)) {
      console.warn("[firebase] config missing, analytics disabled");
      return;
    }
    try {
      const app = initializeApp(firebaseConfig);
      analytics = getAnalytics(app);
    } catch (e) {
      console.warn("[firebase] init failed, analytics disabled", e);
    }
  }

  function trackScreen(name, path) {
    if (!analytics) return;
    try {
      setCurrentScreen(analytics, name);
      logEvent(analytics, "page_view", { page_title: name, page_path: path });
    } catch (e) {
      console.warn("[firebase] trackScreen failed", e);
    }
  }

  function logEvent_(name, params = {}) {
    if (!analytics) return;
    try {
      logEvent(analytics, name, params);
    } catch (e) {
      console.warn("[firebase] logEvent failed", e);
    }
  }

  function setUser(id, props = {}) {
    if (!analytics) return;
    try {
      if (id) setUserId(analytics, id);
      if (Object.keys(props).length) setUserProperties(analytics, props);
    } catch (e) {
      console.warn("[firebase] setUser failed", e);
    }
  }

  return { initFirebase, trackScreen, logEvent: logEvent_, setUser };
}
